import(/* webpackMode: "eager" */ "/vercel/path0/@next/pages/privacy-policy/privacy-policy.tsx");
